import React from 'react';
import ReactDOM from 'react-dom';
import Toast from 'react-native-toast-notifications';

export function ToastHostWeb({ toastRef }: { toastRef: React.RefObject<Toast> }) {
  if (typeof document === 'undefined') return null;

  return ReactDOM.createPortal(
    <div
      style={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 999999,
      }}>
      <Toast ref={toastRef} />
    </div>,
    document.body
  );
}
